import axios from "axios";

export async function loadDocuments(params) {
  return axios.get("/regulations", { params });
}

export async function loadDocument(id) {
  return axios.get(`/regulations/${id}`).then(r => r.data);
}
